export class UiHelper {
  static isLargeScreen(): boolean {
    return false;
  }
  static isLargeScreenReal(): boolean {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return (width > 720);
  }

  static decodeHtmlEntities(text: string): string {
    const parser = new DOMParser();
    return parser.parseFromString(text, "text/html").body.innerText;
  }

  static downloadFileOld(file: any, fileName: string): void {
    let url = window.URL.createObjectURL(file);
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.target = '_system';
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  static checkHeight(): string {
    return window.innerHeight + ' ' + window.innerWidth;
  }
  static absoluteUrl(url: string): string {
    return `/${url}`;
  }

  static capitalizeFirstLetter(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  static generateStrongPassword(length: number = 10): string {
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+[]{}|;:,.<>?';

    const allChars = uppercase + lowercase + numbers + symbols;
    let password = '';

    // Ensure at least one character from each category
    password += uppercase[Math.floor(Math.random() * (uppercase.length -1))];
    password += lowercase[Math.floor(Math.random() * (lowercase.length -1))];
    password += numbers[Math.floor(Math.random() * (numbers.length -1))];
    password += symbols[Math.floor(Math.random() * (symbols.length - 1))];

    // Fill the remaining characters randomly
    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * (allChars.length - 1))];
    }

    // Shuffle the password for randomness
    let final = password.split('').sort(() => 0.5 - Math.random()).join('');
    return uppercase[Math.floor(Math.random() * uppercase.length)] + final + '@';
  }



}
